import { AlertReasonCategory } from './alert-reason-category';
import { AlertStatesBaseCountersModel } from './alert-states-base-counters-model';

export class AlertStatesReasonCountersModel extends AlertStatesBaseCountersModel {
  reasonCategory: AlertReasonCategory|null;
}
